import React from "react";

/** Compact label for API keys or fixed CMS item ids. */
function CmsKeyChip({ value, title, prefixIcon, variant = "field" }) {
  if (!value) return null;

  const className = ["cms-key-chip", `cms-key-chip--${variant}`]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={className} title={title}>
      {prefixIcon ? (
        <span className="cms-key-chip__prefix" aria-hidden="true">
          {prefixIcon}
        </span>
      ) : null}
      <span className="cms-key-chip__text">{value}</span>
    </span>
  );
}

export default CmsKeyChip;
